import { isAppleWalletSupported } from '../apple-wallet/utils';
/**
 * Google Pay is technically supported by all devices, but as we don't support showing both an Apple Wallet and Google Pay button
 * at the same time, we only support Google Pay on devices that don't support Apple Wallet.
 */
export const isGooglePaySupported = () => !isAppleWalletSupported();
/**
 * Opening the Google Pay URL will prompt the patron to add the pass to their Google Pay wallet.
 */
export const openGooglePayPass = (googlePayPass) => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = `https://pay.google.com/gp/v/save/${googlePayPass.jwt}`;
    link.click();
};
